import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Icon_root__Uzney{color:inherit;display:inline-block;pointer-events:none}.Icon_size-xs__T-Npk{height:8px;width:8px}.Icon_size-s__qftZG{height:12px;width:12px}.Icon_size-m__7xCDX{height:16px;width:16px}.Icon_size-l__Eq1Fb{height:20px;width:20px}.Icon_size-xl__ChZL5{height:26px;width:26px}";
var S = {"root":"Icon_root__Uzney","size-xs":"Icon_size-xs__T-Npk","size-s":"Icon_size-s__qftZG","size-m":"Icon_size-m__7xCDX","size-l":"Icon_size-l__Eq1Fb","size-xl":"Icon_size-xl__ChZL5"};
styleInject(css_248z);

export { S as default };
